import i18n from '../i18n.config';

const MONTH_KEYS = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];

function normalizeMonth(month) {
	return String(month || '').trim().toLowerCase();
}

export function formatMonthLabel(month) {
	const normalizedMonth = normalizeMonth(month);
	if (!normalizedMonth) return '';

	return normalizedMonth.charAt(0).toUpperCase() + normalizedMonth.slice(1);
}

export function getLocalizedMonthNames() {
	return MONTH_KEYS.map((monthKey) =>
		formatMonthLabel(i18n.t(`monthFull.${monthKey}`))
	);
}

export function getLocalizedMonthIndex() {
	return getLocalizedMonthNames().reduce((acc, month, index) => {
		acc[normalizeMonth(month)] = index;
		return acc;
	}, {});
}

export function sortMonths(months) {
	const monthIndex = getLocalizedMonthIndex();

	return Object.entries(months).sort(([monthA], [monthB]) => {
		const orderA = monthIndex[normalizeMonth(monthA)];
		const orderB = monthIndex[normalizeMonth(monthB)];

		return (orderA ?? Number.MAX_SAFE_INTEGER) - (orderB ?? Number.MAX_SAFE_INTEGER);
	});
}
